export const TokenService = {

    getUser: function () {
        const userObject = sessionStorage.getItem('user');
        const user = JSON.parse(userObject);
        return user;
    },

    saveUser: function (response) {
        sessionStorage.setItem('user', JSON.stringify(response));
    },

    getHeaders: function () {
        const user = TokenService.getUser();        
        if (user != null && user.accessToken != null)
            return { 'Authorization': 'Bearer ' + user.accessToken }
        else
            return "";
    },

    getAuthorizationBearer: function () {
        const user = TokenService.getUser();        
        if (user != null && user.accessToken != null)
            return 'Bearer ' + user.accessToken; 
        else
            return "";
    },

    getUserGroups: function () {
        const grpupObject = sessionStorage.getItem('groups');
        const groups = JSON.parse(grpupObject) || [];
        return groups;
    },

    saveUserGroups: function (response) {
        sessionStorage.setItem('groups', JSON.stringify(response));
    }


};